export interface AvatarData {
  color: string;
  icon: string | null;
  initials: string;
  photoUrl: string | null;
}

// Pictogrammes proposés pour l'avatar de repli (la liste est fermée côté serveur).
export const AVATAR_EMOJI: Record<string, string> = {
  chef: '👨‍🍳',
  wine: '🍷',
  cocktail: '🍸',
  coffee: '☕',
  fire: '🔥',
  star: '⭐',
  heart: '❤️',
  bolt: '⚡',
  smile: '😊',
  crown: '👑',
};

/** Photo si la personne qui consulte a le droit de la voir, sinon avatar (pictogramme choisi ou initiales). */
export function Avatar({ avatar, size = 44, label }: { avatar?: AvatarData | null; size?: number; label?: string }) {
  const base = { width: size, height: size, borderRadius: '50%', flexShrink: 0 } as const;
  if (avatar?.photoUrl) {
    return <img src={avatar.photoUrl} alt={label ?? ''} width={size} height={size} style={{ ...base, objectFit: 'cover', background: 'var(--surface-2, #eee)' }} />;
  }
  const emoji = avatar?.icon ? AVATAR_EMOJI[avatar.icon] : null;
  return (
    <span
      role="img"
      aria-label={label ?? 'Avatar'}
      style={{
        ...base,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: avatar?.color ?? '#8a8a8a',
        color: '#fff',
        fontWeight: 800,
        fontSize: Math.round(size * (emoji ? 0.5 : 0.38)),
        letterSpacing: emoji ? 0 : 0.5,
        userSelect: 'none',
      }}
    >
      {emoji ?? avatar?.initials ?? '?'}
    </span>
  );
}
